import * as normalize from 'utils/normalize';
import getPatientName from 'utils/print/getPatientName';
import getPatientRecordNumber from 'utils/print/getPatientRecordNumber';
import getSignature from 'utils/print/getSignature';
import getBusinessName from 'utils/print/getBusinessName';
import getFacilityName from 'utils/print/getFacilityName';
import getBusinessStreet from 'utils/print/getBusinessStreet';
import getFacilityStreet from 'utils/print/getFacilityStreet';
import getBusinessCityStateZip from 'utils/print/getBusinessCityStateZip';
import getFacilityCityStateZip from 'utils/print/getFacilityCityStateZip';
import getBusinessPhone from 'utils/print/getBusinessPhone';
import getFacilityPhone from 'utils/print/getFacilityPhone';
import getBusinessFax from 'utils/print/getBusinessFax';
import getFacilityFax from 'utils/print/getFacilityFax';
import getSignatureDate from 'utils/print/getSignatureDate';

const DeliveryTicketEquipmentWarrantyInformationForm = {
  ID: 16,
  Name: 'Equipment Warranty Information Form',
  Type: 'Delivery Ticket',
  Format: 'letter',
  Orientation: 'p',
  Pages: [
    {
      ID: 1,
      imageUrl: 'assets/documents/Delivery-Ticket-Equipment-Warranty-Information-Form/1.js',
      Logo: {
        x: 20,
        y: 20,
        width: 75,
        height: 29,
      },
      texts: [
        {
          name: 'Business Name',
          getText: props => getFacilityName(props) || getBusinessName(props),
          x: 108,
          y: 7,
          align: 'center',
          fontStyle: 'italic',
          fontSize: 10,
          lineHeight: 1.2,
        },
        {
          name: 'Business Street',
          getText: props => getFacilityStreet(props) || getBusinessStreet(props),
          x: 138,
          y: 27,
          fontWeight: 'bold',
          fontSize: 8,
          lineHeight: 1.2,
        },
        {
          name: 'Business City State Zip',
          getText: props => getFacilityCityStateZip(props) || getBusinessCityStateZip(props),
          x: 138,
          y: 30.5,
          fontWeight: 'bold',
          fontSize: 8,
          lineHeight: 1.2,
        },
        {
          name: 'Business Phone',
          getText: props => getFacilityPhone(props) ? `Tel: ${getFacilityPhone(props)}` : `Tel: ${getBusinessPhone(props)}`,
          x: 138,
          y: 34,
          fontWeight: 'bold',
          fontSize: 8,
          lineHeight: 1.2,
        },
        {
          name: 'Business Fax',
          getText: props => getFacilityFax(props) ? `Fax: ${getFacilityFax(props)}` : `Fax: ${getBusinessFax(props)}`,
          x: 138,
          y: 37.5,
          fontWeight: 'bold',
          fontSize: 8,
          lineHeight: 1.2,
        },
        {
          name: 'Copy 1',
          getText: props => `Every product sold or rented by our company carries a 1-year manufacturer's warranty.
          ${getFacilityName(props) || getBusinessName(props)} will notify all Medicare beneficiaries of the warranty coverage, and we will honor all warranties under applicable law.`,
          x: 19,
          y: 78,
          width: 180,
          fontSize: 12,
          lineHeight: 1.2,
        },
        {
          name: 'Copy 2',
          getText: props => `${getFacilityName(props) || getBusinessName(props)} will repair or replace, free to charge, Medicare-covered equipment that is under warranty. In addition, an owner's manual with warranty information will be provided to beneficiaries for all durable medical equipment where this manual is available. I have been instructed and understand the warranty coverage on the product I have received.`,
          x: 19,
          y: 104,
          width: 180,
          fontSize: 12,
          lineHeight: 1.2,
        },
      ],
      fields: [
        {
          name: 'Patient Name',
          type: 'text',
          getValue: getPatientName,
          x: 54,
          y: 154.5,
          width: 75,
        },
        {
          name: 'Patient Record Number',
          type: 'text',
          getValue: getPatientRecordNumber,
          x: 142,
          y: 154.5,
          width: 53,
        },
        {
          name: 'Signature',
          type: 'signature',
          getValue: getSignature,
          x: 60,
          y: 176,
          width: 67,
          height: 18,
        },
        {
          name: 'Date',
          type: 'text',
          getValue: getSignatureDate,
          x: 142,
          y: 189,
          width: 53,
          normalize: normalize.date,
        },
      ],
    },
  ],
};

export default DeliveryTicketEquipmentWarrantyInformationForm;



// WEBPACK FOOTER //
// ./src/config/documents/Delivery-Ticket-Equipment-Warranty-Information-Form.js